<div
  class="modal-wrapper"
  *ngIf="showForm"
  [ngClass]="{ loaded: loaded && loaded['loaded'] }"
>
  <div class="wrapper">
    <div
      class="under-wrapper with-navigation-bar"
      [ngClass]="{ loaded: loaded && loaded['loaded'] }"
      sdClickOutside
      (clickOutside)="closeModal($event)"
      #parent
      [parentRef]="parent"
    >
      <div class="navigation-bar">
        <span class="arrow-back ai ai-back" (click)="closeModal($event)"></span>
        <span class="heading5">{{ getProperHeader() }}</span>
        <div class="img-wrapper cancel" (click)="closeModal($event)">
          <i class="ai ai-cancel"></i>
        </div>
      </div>
      <div class="separator-gray full-height separator-one-half"></div>
      <div class="header">
        <div (click)="closeModal($event)" class="close-button">
          <i class="ai ai-cancel"></i>
        </div>
        <div class="heading2 font-style-semi main-title">
          {{ getProperHeader() }}
        </div>
        <div
          class="button-wrapper"
          *ngIf="addressType != addressTypeInterface.CONTACT"
        >
          <div
            class="button radio-button"
            [ngClass]="{ active: address.personal == true }"
            (click)="toggleAccountType('personal')"
          >
            {{
              addressType != addressTypeInterface.BILLING
                ? ("cart.buyAsPerson" | translate)
                : ("cart.deliveryToPerson" | translate)
            }}
          </div>
          <div
            class="button radio-button"
            [ngClass]="{ active: address.personal == false }"
            (click)="toggleAccountType('company')"
          >
            {{
              addressType != addressTypeInterface.BILLING
                ? ("cart.buyAsCompany" | translate)
                : ("cart.deliveryToCompany" | translate)
            }}
          </div>
        </div>
      </div>
      <form class="contact-data-section" [formGroup]="addressForm">
        <div
          class="input-label show-company"
          *ngIf="
            addressType != addressTypeInterface.CONTACT && !address.personal
          "
        >
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="text"
            [placeholder]="companyNamePlaceholder"
            [formControlName]="ControlNames.COMPANY"
            [name]="ControlNames.COMPANY"
            [id]="ControlNames.COMPANY"
            #showCompanyInput
          />
          <label
            (click)="showCompanyInput.focus()"
            class="form-label"
            [for]="ControlNames.COMPANY"
            [ngClass]="{ 'is-Empty': showCompanyInput.value == '' }"
            >{{ companyNamePlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.COMPANY]"
          ></sd-errors>
        </div>

        <div
          class="input-label show-firstName"
          *ngIf="nameNecessary || address.personal"
        >
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="text"
            [placeholder]="firstNamePlaceholder"
            [formControlName]="ControlNames.FIRSTNAME"
            [name]="ControlNames.FIRSTNAME"
            [id]="ControlNames.FIRSTNAME"
            #showFirstNameInput
          />
          <label
            class="form-label"
            [for]="ControlNames.FIRSTNAME"
            [ngClass]="{ 'is-Empty': showFirstNameInput.value == '' }"
            >{{ firstNamePlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.FIRSTNAME]"
          ></sd-errors>
        </div>
        <div
          class="input-label show-secondName"
          *ngIf="nameNecessary || address.personal"
        >
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="text"
            [placeholder]="secondNamePlaceholder"
            [formControlName]="ControlNames.SECONDNAME"
            [name]="ControlNames.SECONDNAME"
            [id]="ControlNames.SECONDNAME"
            #showSecondNameInput
          />
          <label
            class="form-label"
            [for]="ControlNames.SECONDNAME"
            [ngClass]="{ 'is-Empty': showSecondNameInput.value == '' }"
            >{{ secondNamePlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.SECONDNAME]"
          ></sd-errors>
        </div>
        <div class="input-label show-email" *ngIf="emailAddressNecessary">
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="email"
            [placeholder]="emailPlaceholder"
            [formControlName]="ControlNames.EMAIL"
            [name]="ControlNames.EMAIL"
            [id]="ControlNames.EMAIL"
            #showEmailInput
          />
          <label
            class="form-label"
            [for]="ControlNames.EMAIL"
            [ngClass]="{ 'is-Empty': showEmailInput.value == '' }"
            >{{ emailPlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.EMAIL]"
          ></sd-errors>
        </div>
        <div class="input-label show-address" *ngIf="addressNecessary">
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="text"
            [placeholder]="addressPlaceholder"
            [formControlName]="ControlNames.ADDRESS"
            [name]="ControlNames.ADDRESS"
            [id]="ControlNames.ADDRESS"
            #showAddressInput
          />
          <label
            class="form-label"
            [for]="ControlNames.ADDRESS"
            [ngClass]="{ 'is-Empty': showAddressInput.value == '' }"
            >{{ addressPlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.ADDRESS]"
          ></sd-errors>
        </div>
        <div class="row">
          <div class="input-label show-postCode" *ngIf="addressNecessary">
            <input
              appInputClick
              appAutofillLabelup
              class="input"
              type="text"
              [placeholder]="postCodePlaceholder"
              [formControlName]="ControlNames.POSTCODE"
              [name]="ControlNames.POSTCODE"
              [id]="ControlNames.POSTCODE"
              #showPostCodeInput
            />
            <label
              class="form-label"
              [for]="ControlNames.POSTCODE"
              [ngClass]="{ 'is-Empty': showPostCodeInput.value == '' }"
              >{{ postCodePlaceholder }}</label
            >
            <sd-errors
              [control]="addressForm.controls[ControlNames.POSTCODE]"
            ></sd-errors>
          </div>
          <div class="input-label show-town" *ngIf="addressNecessary">
            <input
              appInputClick
              appAutofillLabelup
              class="input"
              type="text"
              [placeholder]="cityPlaceholder"
              [formControlName]="ControlNames.CITY"
              [name]="ControlNames.CITY"
              [id]="ControlNames.CITY"
              #showTownInput
            />
            <label
              class="form-label"
              [for]="ControlNames.CITY"
              [ngClass]="{ 'is-Empty': showTownInput.value == '' }"
              >{{ cityPlaceholder }}</label
            >
            <sd-errors
              [control]="addressForm.controls[ControlNames.CITY]"
            ></sd-errors>
          </div>
        </div>
        <div class="input-label show-phone" *ngIf="phoneNecessary">
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="text"
            [placeholder]="phonePlaceholder"
            [formControlName]="ControlNames.PHONE"
            [name]="ControlNames.PHONE"
            [id]="ControlNames.PHONE"
            #showPhoneInput
          />
          <label
            class="form-label"
            [for]="ControlNames.PHONE"
            [ngClass]="{ 'is-Empty': showPhoneInput.value == '' }"
            >{{ phonePlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.PHONE]"
          ></sd-errors>
        </div>

        <div
          class="input-label show-taxId"
          *ngIf="
            addressType == addressTypeInterface.BILLING && !address.personal
          "
        >
          <input
            appInputClick
            appAutofillLabelup
            class="input"
            type="email"
            [placeholder]="taxIdPlaceholder"
            [formControlName]="ControlNames.TAX_ID"
            [name]="ControlNames.TAX_ID"
            [id]="ControlNames.TAX_ID"
            #showTaxIDlInput
          />
          <label
            class="form-label"
            [for]="ControlNames.TAX_ID"
            [ngClass]="{ 'is-Empty': showTaxIDlInput.value == '' }"
            >{{ taxIdPlaceholder }}</label
          >
          <sd-errors
            [control]="addressForm.controls[ControlNames.TAX_ID]"
          ></sd-errors>
        </div>
      </form>

      <div class="button-wrapper">
        <button
          class="button primary-button"
          #nextButton
          (click)="savePersonalData()"
        >
          <span [ngClass]="{ loader: isLoading }"></span
          >{{ isLoading ? "" : ("save" | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>
